"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var react_1 = __importStar(require("react"));
var react_perfect_scrollbar_1 = __importDefault(require("react-perfect-scrollbar"));
var react_router_dom_1 = require("react-router-dom");
var hooks_1 = require("../../hooks");
var store_1 = require("../../store");
var Guide_1 = __importDefault(require("../Guide"));
var MenuItemContent_1 = __importDefault(require("./MenuItemContent"));
var SubMenu = antd_1.Menu.SubMenu;
var initialValues = { openKeys: [], selectedKeys: [], help: [] };
var Menu = function (props) {
    var topArea = props.topArea, menu = props.menu;
    var permissions = store_1.useStore(function (state) { return state.permission; }).permissions;
    var setGuide = store_1.useActions(function (state) { return state.ui.setGuide; });
    var location = hooks_1.useRouter().location;
    var _a = react_1.useState(initialValues), selectedItem = _a[0], setSelectedItem = _a[1];
    react_1.useEffect(function () {
        var item;
        if (location.pathname.indexOf('/detail') > 0) {
            item = getSelectedItem(menu, location.pathname.substr(0, location.pathname.indexOf('/detail')));
        }
        else if (location.pathname.indexOf('/new') > 0) {
            item = getSelectedItem(menu, location.pathname.substr(0, location.pathname.indexOf('/new')));
        }
        else {
            item = getSelectedItem(menu, location.pathname);
        }
        if (item) {
            setSelectedItem(item);
        }
    }, [menu, location]);
    react_1.useEffect(function () {
        if (selectedItem) {
            var guide = mountGuide(selectedItem.help);
            setGuide(guide);
        }
    }, [selectedItem, setGuide]);
    var topAreaMenu = react_1.useMemo(function () {
        return topArea.map(function (m) {
            return m.items && m.items.length ? mountSubMenuItem(m, permissions) : mountMenuItem(m, true, permissions);
        });
    }, [topArea, permissions]);
    var menuItems = react_1.useMemo(function () {
        return menu.map(function (m) {
            return m.items && m.items.length ? mountSubMenuItem(m, permissions) : mountMenuItem(m, false, permissions);
        });
    }, [menu, permissions]);
    var handleOpenChange = function (openKeys1) {
        var sub = false;
        var latestOpenKey = openKeys1.find(function (key) { return selectedItem.openKeys.indexOf(key) === -1; });
        menu.map(function (item) {
            if (item.label === latestOpenKey) {
                return (sub = true);
            }
        });
        if (!sub) {
            setSelectedItem(__assign({}, selectedItem, { openKeys: openKeys1 }));
        }
        else {
            setSelectedItem(__assign({}, selectedItem, { openKeys: latestOpenKey ? [latestOpenKey] : [] }));
        }
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(antd_1.Menu, { theme: "dark", mode: "inline" }, topAreaMenu),
        react_1.default.createElement(react_perfect_scrollbar_1.default, null,
            react_1.default.createElement("div", { className: "ant-app-menu-container" },
                react_1.default.createElement(antd_1.Menu, { theme: "dark", mode: "inline", openKeys: selectedItem.openKeys, selectedKeys: selectedItem.selectedKeys, onOpenChange: handleOpenChange }, menuItems)))));
};
exports.default = react_1.memo(Menu);
var getSelectedItem = function (menu, uri, parentKey) {
    var selectedItem = {
        openKeys: [],
        selectedKeys: [],
    };
    menu.forEach(function (m) {
        if (!selectedItem.openKeys.length && !selectedItem.selectedKeys.length) {
            if (m.uri === uri) {
                selectedItem.openKeys = parentKey ? [parentKey] : [];
                selectedItem.selectedKeys = [m.label];
                selectedItem.help = m.help;
            }
            else if (m.items) {
                selectedItem = getSelectedItem(m.items, uri, m.label);
            }
        }
    });
    return selectedItem;
};
var mountMenuItem = function (menu, topArea, permissions) {
    if (menu.items && menu.items.length)
        return mountSubMenuItem(menu, permissions);
    if (!hasPermission(permissions, menu.permissions))
        return react_1.default.createElement("div", { key: menu.label });
    var content = react_1.default.createElement(MenuItemContent_1.default, { key: menu.label, icon: menu.icon, label: menu.label, topArea: topArea });
    return react_1.default.createElement(antd_1.Menu.Item, { key: menu.label }, menu.uri ? react_1.default.createElement(react_router_dom_1.Link, { to: menu.uri }, content) : content);
};
var mountSubMenuItem = function (menu, permissions) {
    if (permissions && mountMenuNotPermissions(permissions, menu) === 0) {
        return react_1.default.createElement("div", { key: menu.label });
    }
    if (!hasPermission(permissions, menu.permissions))
        return react_1.default.createElement("div", { key: menu.label });
    return (react_1.default.createElement(SubMenu, { key: menu.label, title: react_1.default.createElement(MenuItemContent_1.default, { icon: menu.icon, label: menu.label }) }, (menu.items || []).map(function (item) { return mountMenuItem(item, false, permissions); })));
};
var mountMenuNotPermissions = function (necessaryPermissions, menu) {
    var menuCount = 0;
    menu.items &&
        menu.items.map(function (item) {
            if (item.items && item.items.length) {
                var itemCount_1 = 0;
                if (item.permissions && item.permissions.length > 0) {
                    item.permissions.map(function (permissionItem) {
                        if (necessaryPermissions.includes(permissionItem)) {
                            itemCount_1 += 1;
                        }
                    });
                }
                else {
                    itemCount_1 = 1;
                }
                if (itemCount_1 > 0) {
                    menuCount += mountMenuNotPermissions(necessaryPermissions, item);
                }
            }
            else if (item.permissions && item.permissions.length > 0) {
                item.permissions.map(function (permissionItem) {
                    if (necessaryPermissions.includes(permissionItem)) {
                        menuCount += 1;
                    }
                });
            }
            else {
                menuCount = 1;
            }
        });
    return menuCount;
};
var mountGuide = function (help) {
    if (!help || !help.length)
        return undefined;
    return (react_1.default.createElement(Guide_1.default, { title: "Help" }, help.map(function (h, index) { return (react_1.default.createElement("p", { key: index }, h.content)); })));
};
var hasPermission = function (necessaryPermissions, permissions) {
    return !necessaryPermissions || !permissions || necessaryPermissions.some(function (p1) { return permissions.some(function (p2) { return p2 === p1; }); });
};
